import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { cloneDeep, isEmpty } from 'lodash'

import { Button } from '@/components/buttons/Button'
import { fetchAdvancedExportsPreviewData } from '@/reducers/realtime/advancedExports/advancedExports.actions'
import { setData } from '@/reducers/realtime/advancedExports/advancedExports.redux'
import { RTCDisplayGroupingOptions } from '@/utils/constants'

export const AdvancedExportsPreviewButton = () => {
  const dispatch = useDispatch()
  const { organizationid: organizationId } = useSelector((state) => state.currentUser)
  const isBaltoAdmin = organizationId === 1
  const { filters } = useSelector((state) => state.realtimeCoaching)
  const { loading } = useSelector((state) => state.realtimeAdvancedExports)
  const isPreviewButtonEnabled =
    (!isEmpty(filters.displayGroupings) && filters.dateRangeIsValid) || loading.table
  const disabledText = isEmpty(filters.displayGroupings)
    ? 'At least one grouped by variable must be selected'
    : 'Please select a valid date range'

  const displayMetrics = filters.displayMetrics.map((filter) => filter.value)
  const displayGroupings = filters.displayGroupings.map((filter) => filter.value)
  const displayFilters = filters
  const combineAndSortColumns = (groupings, metrics) => {
    return [
      ...groupings.sort(
        (firstGrouping, secondGrouping) =>
          RTCDisplayGroupingOptions.findIndex(
            (currentGrouping) => currentGrouping.value === firstGrouping.value
          ) -
          RTCDisplayGroupingOptions.findIndex(
            (currentGrouping) => currentGrouping.value === secondGrouping.value
          )
      ),
      ...metrics,
    ]
  }

  const submitClick = () => {
    dispatch(
      fetchAdvancedExportsPreviewData(
        isBaltoAdmin ? filters.organization : organizationId,
        displayMetrics,
        displayGroupings,
        displayFilters
      )
    )
    const columnsToDisplay = combineAndSortColumns(
      cloneDeep(filters.displayGroupings),
      cloneDeep(filters.displayMetrics)
    )
    dispatch(setData({ columns: columnsToDisplay }))
  }

  return (
    <div className="form-actions left-aligned mt">
      <Button
        brand
        onClick={submitClick}
        data-testid="preview-button"
        disabled={!isPreviewButtonEnabled || loading.table}
        loading={loading.table}
        disabledTooltip={disabledText}
        tooltipProps={{ placement: 'top-start' }}
      >
        Preview
      </Button>
    </div>
  )
}
